import { UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY } from '../../constants/actionTypes';
import { SEND_APPLICATION_INVITATION } from '../../constants/requests';

const initialState = null;

export default function inviteInfoFromLeadInquiry(state = initialState, action) {
  switch (action.type) {
    case UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY:
      return action.payload.inviteInfoFromLeadInquiry;
    case SEND_APPLICATION_INVITATION.RECEIVE:
      return initialState;
    default:
      return state;
  }
}
